import React from 'react';
import { NavLink } from 'react-router-dom';

import { checkIsCmsLink } from 'utils';
import SmartLink from '../SmartLink';

import './NavButton.scss';

interface OwnProps {
    link: string;
    isDisable: boolean;
}

type Props = OwnProps;

const NavButton: React.FC<Props> = ({ link, isDisable, children }) => {
    if (isDisable) {
        return (
            <div
                styleName="button"
                className="__app-NavButton-button __app-NavButton-is-active"
            >
                {children}
            </div>
        );
    }

    if (checkIsCmsLink(link)) {
        return (
            <SmartLink
                to={link}
                styleName="button"
                className="__app-NavButton-button"
            >
                {children}
            </SmartLink>
        );
    }

    return (
        <NavLink
            to={link}
            exact={true}
            styleName="button"
            className="__app-NavButton-button"
            activeClassName="__app-NavButton-is-active"
        >
            {children}
        </NavLink>
    );
};

export default NavButton;
